import { Fragment, useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as Logo } from 'assets/Common/logo.svg'
import { ReactComponent as LogoBlack } from 'assets/Common/logoBlack.svg'
import { ReactComponent as Request } from 'assets/Common/request.svg'
import { ReactComponent as RequestMo } from 'assets/Common/requsetMo.svg'
import { ReactComponent as Menu } from 'assets/Common/menu.svg'
import { ReactComponent as MenuBlack } from 'assets/Common/menuBlack.svg'
import { ReactComponent as Close } from 'assets/Common/close.svg'
import { ReactComponent as Download } from 'assets/Common/download.svg'
import RotateLogoPng from 'assets/Common/Menu/logo.avif'
import './style.css'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion'
import {
  END_ANIMATION_PROPERTY,
  START_ANIMATION_PROPERTY,
  VIEWPORT_PROPERTY,
} from 'constants/animation-properties'
import { CircularRevealPanel } from 'react-circular-reveal'

const Header = ({ isOverLay, isWhite, bgWhite }: any) => {
  const { isTablet } = useContext(GlobalContext)
  const [isOpened, setOpened] = useState<boolean>(false)
  const menu = [
    { title: 'ABOUT', id: 0, url: '/about' },
    { title: 'EXPRIENCE', id: 1, url: '/experience' },
    { title: 'NEWS', id: 2, url: '/news' },
    { title: 'CONTACT', id: 3, url: '/contact' },
  ]

  useEffect(() => {
    const handleResize = () => setOpened(false);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Fragment>
      <div className={`fixed top-0 left-0 w-full ${isOpened ? 'z-40' : '-z-40'} pointer-events-none`}>
        <CircularRevealPanel
          reveal={isOpened}
          speed={'normal'}
          contentMinWidth={500}
          revealContent={
            isTablet ?
              <div className={'revealed bg-black h-screen flex flex-col justify-between'} >
                <div className="flex justify-between items-center tablet:px-4 tablet:py-2 container">
                  <Link to={'/'} className="cursor-pointer">
                    <Logo className={'h-18 w-[116px] tablet:h-[63px]'} />
                  </Link>
                  <Close
                    className={`cursor-pointer w-10`}
                    onClick={() => {
                      setOpened(false)
                    }}
                  />
                </div>

                <div className='w-full'>
                  <ul className="flex flex-col justify-center items-center gap-[3vh]">
                    {menu.map((item, idx) => (
                      <motion.li
                        key={idx}
                        transition={{ delay: 0.1 * idx }}
                        className="menuItemMo"
                        initial={START_ANIMATION_PROPERTY}
                        whileInView={END_ANIMATION_PROPERTY}
                        viewport={VIEWPORT_PROPERTY}>
                        <p>
                          <Link to={item.url} className="text-44">
                            {item.title}
                          </Link>
                        </p>
                      </motion.li>
                    ))}
                  </ul>
                </div>

                <div className='flex flex-col items-center gap-4'>
                  <motion.div
                    className='flex gap-4 px-10 py-4 border-1 border-white cursor-pointer'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}>
                    <Download />
                    <a
                      href='/files/TINS LAB_Introduction.pdf'
                      className="text-white"
                      download>
                      회사소개서
                    </a>
                  </motion.div>

                  <div className='mb-8 px-6'>
                    <p className='text-darkgray text-xs'>주소 : 서울특별시 강서구 마곡중앙8로 14, 서울창업허브M+ 408호</p>
                    <div className='flex justify-between'>
                      <p className='text-darkgray text-xs'>이메일 : sales@tinslab.co.kr</p>
                      <p className='text-darkgray text-xs'>연락처 : 02-2132-8688</p>
                    </div>
                  </div>
                </div>
              </div> :

              <div className={'revealed bg-black h-screen flex flex-col justify-between px-6 '} >
                <div className="flex justify-between items-center container">
                  <Link to={'/'} className="cursor-pointer">
                    <Logo className={`h-18 w-[150px]`} />
                  </Link>
                  <Close
                    className={`cursor-pointer 'w-10'}`}
                    onClick={() => {
                      setOpened(false)
                    }}
                  />
                </div>

                <div className='relative flex items-center container'>
                  <div className='z-20 relative flex items-center w-7/10 h-[60vh]'
                    style={{ background: 'linear-gradient(90deg, rgba(20,20,20,1) 92%, rgba(255,255,255,0) 95%)' }}>
                    <ul
                      className="flex flex-col justify-center items-start gap-10"
                    >
                      {menu.map((item, idx) => (
                        <motion.li
                          key={idx}
                          transition={{ delay: 0.1 * idx }}
                          className="menuItem"
                          initial={START_ANIMATION_PROPERTY}
                          whileInView={END_ANIMATION_PROPERTY}
                          viewport={VIEWPORT_PROPERTY}>
                          <p>
                            <Link to={item.url} className="mb-7 text-8xl cursor-pointer">
                              {item.title}
                            </Link>
                          </p>
                        </motion.li>
                      ))}
                    </ul>
                  </div>

                  <motion.div
                    className='top-[0] right-[5%] z-0 absolute h-[60vh]'
                    animate={{ rotate: 360 }}
                    transition={{
                      repeat: Infinity,
                      duration: 120,
                      ease: "linear",
                    }}
                    viewport={VIEWPORT_PROPERTY}>
                    <img className='w-[100%] h-[100%]' src={RotateLogoPng} alt="RotateLogoPng" />
                  </motion.div>
                </div>

                <div className='flex justify-between items-center mb-15 container'>
                  <div className='flex flex-col gap-2'>
                    <p className='text-darkgray'>주소 : 서울특별시 강서구 마곡중앙8로 14, 서울창업허브M+ 408호</p>
                    <p className='text-darkgray'>이메일 : sales@tinslab.co.kr</p>
                    <p className='text-darkgray'>연락처 : 02-2132-8688</p>
                  </div>

                  <motion.div
                    className='flex gap-4 px-10 py-4 border-1 border-white cursor-pointer'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}>
                    <Download />
                    <a
                      href='/files/tinslab_Introduction.pdf'
                      className="text-white"
                      download>
                      회사소개서
                    </a>
                  </motion.div>
                </div>
              </div>
          }>
          <div className={'content h-screen'}></div>
        </CircularRevealPanel>
      </div>

      {
        isWhite ?
          <div className={`w-full fixed z-30 bg-white`}>
            <header className="tablet:px-4 tablet:py-2 h-18 container">
              <div className="flex justify-between items-center gap-8 w-full">
                <Link to={'/'} className="cursor-pointer">
                  <LogoBlack className={`h-18 tablet:w-[116px] tablet:h-[63px]`} />
                </Link>
                <div className="flex flex-1 justify-end items-center gap-5">
                  <div onClick={() => { }} className={`bg-black px-4 py-3 rounded-lg`}>
                    <Request className="cursor-pointer" />
                  </div>
                  <div onClick={() => { setOpened(true) }}>
                    <MenuBlack className="w-10 cursor-pointer" />
                  </div>
                </div>
              </div>
            </header>
          </div> :

          <div className={`w-full fixed z-30 ${bgWhite && 'bg-white'}`}>
            <header className="tablet:px-4 tablet:py-2 h-18 tablet:h-[69px] container">
              <div className="flex justify-between items-center gap-8 w-full">
                <Link to={'/'} className="cursor-pointer">
                  {
                    !isOverLay ?
                      <Logo className={`h-18 w-[150px] tablet:w-[116px] tablet:h-[63px]`} /> :
                      <LogoBlack className={`h-18 w-[150px] tablet:w-[116px] tablet:h-[63px]`} />
                  }
                </Link>
                <div className={`flex justify-end items-center flex-1 gap-5 tablet:gap-0`}>
                  <div onClick={() => { }} className={`${isOverLay && 'bg-black'} px-4 py-1 rounded-lg tablet:hidden`}>
                    <Link to={'/request'} className="mb-7 cursor-pointer">
                      <Request className="w-[110px] cursor-pointer" />
                    </Link>
                  </div>
                  <div onClick={() => { }} className={`px-4 rounded-lg hidden tablet:block`}>
                    <Link to={'/request'} className="mb-7 cursor-pointer">
                      <RequestMo fill={!isOverLay ? 'white' : 'black'} />
                    </Link>
                  </div>
                  <div onClick={() => { setOpened(true) }}>
                    {
                      !isOverLay ?
                        <Menu className={`cursor-pointer w-10`} /> :
                        <MenuBlack className={`cursor-pointer w-10`} />
                    }
                  </div>
                </div>
              </div>
            </header>
          </div>

      }
    </Fragment>
  )
}

export default Header
